import { Inject, Injectable } from '@angular/core';
import { IAnalyticsEvent, WINDOW } from "@services";

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(@Inject(WINDOW) private window: Window) {}

  track(event: IAnalyticsEvent): void {
    (this.window as any).dataLayer.push({ event: event.name, ...event.data });
  }
}
